var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirmTitle":_vm.title,"description":_vm.description,"isQuestion":false},on:{"cancel":function($event){return _vm.$emit('closeModal')},"confirm":function($event){return _vm.$emit('confirm')}}},[_c('icon-single-payment',{attrs:{"size":80}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }